// extracted by mini-css-extract-plugin
export var required = "_f0-0";